<template>
    <div v-if="showStep" class="step-card-wrapper">
        <generic-step-card
            :title="stepTitle"
            :current-step-name="currentStepName"
            :step="step"
            :is-preview="isPreview"
            :is-brief-accepted="isBriefAccepted"
            :is-brief-editable="isBriefEditable"
            :brief="brief"
            :sub-title="subtitle"
        >
            <template v-if="step.is_complete || isBriefAccepted" slot="details">
                <tasks-list :tasks="selectedTasks" :brief-accepted="isBriefAccepted" />
            </template>
        </generic-step-card>
    </div>
</template>

<script>
    import GenericStepCard from '../GenericStepCard';
    import {NAME_TASKS} from '../../../../../constants/activation-brief-steps';
    import StepCardViewMixin from '../mixins/StepCardViewMixin';
    import ActivationTasksMixin from './../../mixins/ActivationTasksMixin';
    import TasksList from '../tasks/TasksList';
    import {pluralize} from '../../../../../helpers/string-helpers';
    import {ACTIVATION_BRIEF_STATUS_NONE} from '../../../../../constants/activation-brief';

    export default {
        name:       'TasksStepCardView',
        components: {
            TasksList,
            GenericStepCard,
        },
        mixins: [
            StepCardViewMixin,
            ActivationTasksMixin,
        ],
        computed: {
            stepName() {
                return NAME_TASKS;
            },
            subtitle() {
                if (this.step.is_complete && this.briefStatus===ACTIVATION_BRIEF_STATUS_NONE) {
                    return `${this.selectedTasks.length} ${pluralize(this.selectedTasks.length, 'Task')}`;
                }
                else if ( this.briefStatus===ACTIVATION_BRIEF_STATUS_NONE) {
                    const optional = this.optionalTasks.length >= 1 ? `${this.optionalTasks.length} optional` : '';
                    const required = this.requiredTasks.length >= 1 ? `${this.requiredTasks.length} required` : '';
                    const comma = optional !== '' && required !== '' ? ', ' : '';
                    return `${required}${comma}${optional}`;
                }
                const complete = this.selectedTasks.filter(task => {
                    return (task.complete_quantity >= task.quantity && task.quantity !== 0);
                });

                const incomplete = this.selectedTasks.filter(task => task.complete_quantity < task.quantity || task.complete_quantity === 0);
                return `${incomplete.length} Incomplete, ${complete.length} Complete`;
            },
        },
    };
</script>

<style lang="scss" scoped>
    .step-card-wrapper {
        margin-bottom: $g-spacing-5;
    }
</style>
